// extracted by mini-css-extract-plugin
export default {"wrapper":"Catalog_wrapper__Piw7c","list":"Catalog_list__rUMOA","total":"Catalog_total__xkrLx","showMore":"Catalog_showMore__8lScw"};